export type ResultMap = {[key: string|number]: any[];};

export class AtLeastOne<T extends ResultMap> {
    private result = {} as T;
    private callBacks: Function[] = [];
    private callBacksCount = 0;
    private mainCallBack?: (res: T) => void;

    collect(mainCallBack: (res: T) => void): void {
        this.mainCallBack = mainCallBack;
        this.runOnEnd();
    }

    cb<K extends keyof T, V extends T[K], FN extends(...args: V) => void>(name?: K, cb?: FN): FN {
        const exportCallBack = (...args: V) => {
            if (name) {
                this.result[name] = args;
            }

            cb?.(...args);

            this.removeCallBack(exportCallBack);
            this.runOnEnd();
        };

        this.callBacks.push(exportCallBack);
        this.callBacksCount ++;

        return exportCallBack as FN;
    }

    cancel(): void {
        this.mainCallBack = undefined;
    }

    private removeCallBack(cb: Function) {
        const index = this.callBacks.indexOf(cb);

        if (index !== -1) {
            this.callBacks.splice(index, 1);
        }
    }

    private runOnEnd() {
        if ((this.callBacksCount !== 0) && (this.callBacks.length === this.callBacksCount)) {
            return;
        }

        this.mainCallBack?.(this.result);
        this.cancel();
    }
}